import { QuestionCircleOutlined } from '@ant-design/icons'
import { Input, Tooltip } from 'antd'
import classNames from 'classnames'
import { useAtom } from 'jotai'
import { MyForm } from '~/components/ui/MyForm'
import styles from '../AiForm.module.css'
import { seedAtom } from './atom'
import { useType } from '../useType'

export const SeedComp: React.FC<{
  disabled: boolean
}> = ({ disabled }) => {
  const [seed, setSeed] = useAtom(seedAtom)

  const { isMJ } = useType()
  const max = isMJ ? 4294967295 : Infinity

  return (
    <MyForm.Item
      label={
        <span>
          随机种子{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="每次生成图的独立唯一编号，编号相同+词参+模型相同的情况下，可复原绘画结果"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
      className={classNames(styles.borderLessFormItem, '!mb-3')}
    >
      <Input
        placeholder={'请输入随机种子'}
        type="number"
        min={1}
        allowClear
        className={styles.colorLessInput}
        value={seed}
        onChange={e => {
          if (!!e.target.value) {
            const _val = Math.floor(Number(e.target.value))
            setSeed(Math.min(max, Math.max(1, _val)).toString())
          } else {
            setSeed(undefined)
          }
        }}
        disabled={disabled}
      />
    </MyForm.Item>
  )
}
